/**
 * scssを読み込み
 */
//import './scss/style.scss';

/**
 * jQueryを読み込み
 */
import $ from 'jquery';

/**
 * Slickを読み込み
 */
import 'slick-carousel';

/**
 * flatpickrを読み込み
 */
import flatpickr from "flatpickr";
import { Japanese } from "flatpickr/dist/l10n/ja.js"

/**
 * Fontawsome
 */
import {config, dom, library} from '@fortawesome/fontawesome-svg-core';
import {faChevronRight,faChevronLeft,faChevronDown,faChevronUp} from '@fortawesome/free-solid-svg-icons';
library.add(faChevronRight,faChevronLeft,faChevronDown,faChevronUp);
dom.i2svg();

 /**
 * ScrollHint
 */
//const ScrollHint = require('scroll-hint');
//window.addEventListener('DOMContentLoaded', function(){
//	new ScrollHint('.js-scrollable');
//});

/**
 * scriptを読み込み
 */
import './js/script.js';
import './js/target_blank.js';
import './js/sns_sharebtn.js';
import './js/slider.js';
import './js/twitter-widget.js';
import './js/header.js';
import './js/scroll_animation.js';
import './js/modal.js';
import './js/floor_map.js';
import './js/tab_change.js';
import './js/barrierfree.js';
